import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ApiError, MessageService, FormsUtilsService, Task, TaskService } from '../../../../../../../core';
import { DatepickerComponent } from '../../../../../../../shared/components/datepicker';
import { ClienteIntegracaoImportFilter } from '../../../cliente-integracao-import-filter';
import { ClienteIntegracaoErpImportHttpService } from '../cliente-integracao-erp-import-http.service';
import { ClienteIntegracaoErpImportService } from '../cliente-integracao-erp-import.service';
import { Integracao, IntegracaoErpHttpService } from '../../../../../../integracao';

@Component({
    selector: 'sgt-cliente-integracao-erp-import-modal',
    templateUrl: './cliente-integracao-erp-import-modal.component.html',
    styleUrls: ['./cliente-integracao-erp-import-modal.component.less']
})
export class ClienteIntegracaoErpImportModalComponent implements OnInit {
    filter: ClienteIntegracaoImportFilter;
    elModal: any;

    @ViewChild('form') form: NgForm;
    @ViewChild('datePickerDataCadastroInicial') datePickerDataCadastroInicial: DatepickerComponent;
    @ViewChild('datePickerDataCadastroFinal') datePickerDataCadastroFinal: DatepickerComponent;
    integracoes: Integracao[];

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private formsUtilsService: FormsUtilsService,
                private taskService: TaskService,
                private integracaoErpHttpService: IntegracaoErpHttpService,
                private clienteIntegracaoErpImportService: ClienteIntegracaoErpImportService,
                private clienteIntegracaoErpImportHttpService: ClienteIntegracaoErpImportHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                this.filter = new ClienteIntegracaoImportFilter();
                this.searchIntegracoes();
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    /** Pesquisa as integrações ativas do tipo ERP */
    private searchIntegracoes() {
        try {
            this.integracoes = [];
            this.integracaoErpHttpService.searchAtivas()
                .subscribe(
                    integracoes => {
                        this.integracoes = integracoes;
                        if (this.integracoes?.length === 1) {
                            this.filter.idIntegracao = this.integracoes[0].id;
                            jQuery(this.elModal).find('#importModalCodigoIntegracao').trigger('focus');
                        } else {
                            jQuery(this.elModal).find('#importModalIntegracao').trigger('focus');
                        }
                    },
                    (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as integrações ativas do tipo ERP', error)
                );
        } catch (error) {
            this.messageService.error('Erro ao pesquisar as integrações ativas do tipo ERP', 'Erro', error);
        }
    }

    /** Obtem a integração informa no array de integrações */
    private getIntegracao(id: number): Integracao {
        return this.integracoes?.find(integracaoFilter => integracaoFilter.id === id);
    }

    private clear() {
        this.filter = null;
    }

    open() {
        this.clear();
        this.elModal.modal({keyboard: false});
    }

    close() {
        this.elModal.modal('hide');
    }

    /** Realiza validação do filtro da importação */
    private validateImport(): boolean {
        this.formsUtilsService.makeAllFieldsDirty(this.form);

        // Data de Cadastro
        if (this.filter.dataCadastroInicial && !this.filter.dataCadastroFinal) {
            this.messageService.warning('Para importar os clientes é necessário informar a data de cadastro final quando a data de cadastro inicial estiver sido informada', 'Filtro Inválido');
            this.datePickerDataCadastroFinal.setFocus();
            return false;
        } else if (!this.filter.dataCadastroInicial && this.filter.dataCadastroFinal) {
            this.messageService.warning('Para importar os clientes é necessário informar a data de cadastro inicial quando a data de cadastro final estiver sido informada', 'Filtro Inválido');
            this.datePickerDataCadastroInicial.setFocus();
            return false;
        }

        // Form Inválido
        if (this.form.invalid) {
            this.messageService.warning('Para importar os clientes é necessário informar corretamente o filtro', 'Filtro Inválido');
            return false;
        }

        return true;
    }

    /** Realiza a importação */
    import() {
        if (!this.validateImport()) {
            return;
        }

        const integracao = this.getIntegracao(this.filter.idIntegracao);
        const nomeIntegracao = integracao?.nome ?? '';
        const task = new Task(`Importando os clientes do ERP ${nomeIntegracao}`, `Realizando importação dos clientes do ERP ${nomeIntegracao}`);
        this.taskService.add(task, task.description);
        this.clienteIntegracaoErpImportHttpService.importMany(this.filter)
            .subscribe(
                (response: any) => {
                    this.taskService.success(task, `Importação dos clientes do ERP ${nomeIntegracao} realizada com sucesso`);
                    this.clienteIntegracaoErpImportService.emitAfterImport();
                },
                (error: ApiError) => {
                    this.taskService.error(task, error.message, error.cause, error);
                }
            );

        this.close();
    }
}
